import {Pipe, PipeTransform} from '@angular/core';

import {ICONS_TYPE} from './icons-type';

/**
 * @description relates string to an icon type
 */
@Pipe({
  name: 'icon'
})
export class IconPipe implements PipeTransform {

  transform(type: string): any {
    const iconsKeys = Object.keys(ICONS_TYPE);
    for (const icon of iconsKeys) {
      if (ICONS_TYPE[icon].some(str => str.toLowerCase().trim() === type.toLowerCase().trim())) {
        return icon;
      }
    }

    return 'default_ico';
  }

}
